// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import * as msalCommon from "@azure/msal-node";

export { msalCommon };
